import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { QueryProvider } from './QueryProvider';
import { FeatureFlagProvider } from './FeatureFlagProvider';
import { SessionGate } from '@/features/auth/components/SessionGate';
import { ErrorBoundary } from '@/components/errors';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryProvider>
      <FeatureFlagProvider>
        <BrowserRouter>
        <ErrorBoundary>
        <SessionGate>
        {children}
        </SessionGate>
        </ErrorBoundary>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              borderRadius: '8px',
              background: 'var(--color-card)',
              color: 'var(--color-card-foreground)',
              fontSize: '14px',
            },
          }}
        />
        </BrowserRouter>
      </FeatureFlagProvider>
    </QueryProvider>
  );
}
